// This project uses gtag.js directly (see public/index.html), not Google
// Tag Manager, so events go straight through window.gtag rather than a
// dataLayer.push GTM would expect. Guarded in case gtag hasn't loaded yet
// (e.g. blocked by an ad blocker) or this runs outside the browser.
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
};
